module.exports = __webpack_public_path__ + "img/emoji_38.8f98e71e.png";